import auth from "./auth";
import http from "./http";
import regionTable from "./regionTable";
import print from "./print";

export default {
  auth,
  http,
  regionTable,
  print
};
